import { Component, signal } from '@angular/core'

import { ICellRendererAngularComp } from 'ag-grid-angular'
import { ICellRendererParams } from 'ag-grid-community'
import { TagModule } from 'primeng/tag'
import { TooltipModule } from 'primeng/tooltip'

@Component({
  imports: [TooltipModule, TagModule],
  template: ` @if (activeIncidents()) {
      <p-tag
        [value]="activeIncidents().toString()"
        class="flx-tag ml-2"
        severity="danger"
      />
    } @else {
      <span class="ml-4">-</span>
    }`,
})
export class FlxActiveIncidentsComponent implements ICellRendererAngularComp {
  activeIncidents = signal<number>(null)

  agInit(params: ICellRendererParams<any, any, any>): void {
    this.activeIncidents.set(params.value)
  }
  refresh(params: ICellRendererParams<any, any, any>): boolean {
    this.activeIncidents.set(params.value)
    return true
  }
}
